import { render, staticRenderFns } from "./HealthData.vue?vue&type=template&id=a9e66e6c"
import script from "./HealthData.vue?vue&type=script&lang=js"
export * from "./HealthData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports